export const patientFileQueryPolicy = {
  xRays: 2 * 60 * 1000,
  media: 2 * 60 * 1000,
  pecDocuments: 30 * 1000,
  payments: 15 * 1000,
  timeSpent: 60 * 1000,
  insuranceCard: 2 * 60 * 1000,
  satisfaction: 60 * 1000,
  consultations: 15 * 1000,
  quotes: 15 * 1000,
  logosActes: 60 * 1000,
  patientStates: 30 * 1000,
};
